import usePermissions from '../../hooks/permissions-hooks';

function RolesComponent({ roles, fallback, ...props }) {
  const { userHasRole } = usePermissions();

  if (userHasRole(roles)) {
    return props.children || null;
  }

  return fallback || null;
}

export default RolesComponent;
